import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getTillAmount,
  RESET_DAYSTART,
  selectDayStartSuccess,
  startDay,
} from "../../redux/features/dayStart/DayStartSlice";

const DayStart = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openingBalance, setOpeningBalance] = useState();
  const dispatch = useDispatch();
  const isSuccess = useSelector(selectDayStartSuccess);

  const handleStartDay = async (openingBalance) => {
    await dispatch(
      startDay({ openingBalance: openingBalance ? openingBalance : 0 })
    );
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(getTillAmount());
      setOpeningBalance();
      dispatch(RESET_DAYSTART());
      setIsOpen(false);
    }
  }, [isSuccess, dispatch]);

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className=" uppercase bg-[#A9A9A9] text-nowrap md:text-[.9rem] text-[.7rem] md:rounded-xl rounded-lg text-white font-semibold md:px-5 px-3  py-2 "
      >
        Day Start
      </button>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] sm:w-[450px] w-[90%] mx-auto p-8 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-2 mb-4">
              <h1 className="md:text-[1.2rem] text-[1rem] font-bold text-[#0D868C]">
                Day Start
              </h1>
              <button type="button" onClick={() => setIsOpen(!isOpen)}>
                <FiX className="md:size-7 size-5 text-[#0D868C]" />
              </button>
            </div>

            <div className="mb-6 flex flex-col items-start">
              <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                Opening Balance
              </label>
              <input
                value={openingBalance}
                onChange={(e) => setOpeningBalance(e.target.value)}
                min={0}
                step={1}
                onWheel={(e) => e.target.blur()}
                type="number"
                placeholder="1000,2000 etc."
                className={`w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] `}
              />
            </div>

            <div className="text-center mt-8">
              <button
                onClick={() => handleStartDay(openingBalance)}
                className="text-white bg-[#0D868C] md:w-[50%] w-full py-3 rounded-full outline-none uppercase font-normal text-[1rem]"
              >
                Day Start
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DayStart;
